import { Action, creator } from 'src/config/rootAction';

import { PlannedActivity } from '../../weekThree/models/weekThree';
import {
    Answer,
    ChangeAccomplishedActivityFeelingActionArguments,
    ChangeAccomplishedActivityFieldActionArguments,
    ChangeFlexibilityExerciseFieldActionArguments,
    ChangeFlexibilityPlanInputArguments,
    ChangeFlexibilityPracticeAnswerArguments,
    ContentAnswer,
    SelectedAnswer,
} from '../models/weekFour';

export const CHANGE_FLEXIBILITY_EXERCISE_ANSWER = 'CHANGE_FLEXIBILITY_EXERCISE_ANSWER';
export type ChangeFlexibilityExerciseAnswerAction = Action<
    typeof CHANGE_FLEXIBILITY_EXERCISE_ANSWER,
    ChangeFlexibilityExerciseFieldActionArguments
>;
export const changeFlexibilityExerciseAnswer = creator<ChangeFlexibilityExerciseAnswerAction>(
    CHANGE_FLEXIBILITY_EXERCISE_ANSWER,
);

export const SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_REQUESTED =
    'SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_REQUESTED';
export type SubmitFlexibilityExerciseAnswersRequestAction = Action<
    typeof SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_REQUESTED,
    Answer[]
>;
export const submitFlexibilityExerciseAnswers = creator<
    SubmitFlexibilityExerciseAnswersRequestAction
>(SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_REQUESTED);

export const SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_SUCCEEDED =
    'SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_SUCCEEDED';
export type SubmitFlexibilityExerciseAnswersSuccessAction = Action<
    typeof SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_SUCCEEDED
>;
export const submitFlexibilityExerciseAnswersSuccess = creator<
    SubmitFlexibilityExerciseAnswersSuccessAction
>(SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_SUCCEEDED);

export const SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_FAILED =
    'SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_FAILED';
export type SubmitFlexibilityExerciseAnswersFailAction = Action<
    typeof SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_FAILED
>;
export const submitFlexibilityExerciseAnswersFail = creator<
    SubmitFlexibilityExerciseAnswersFailAction
>(SUBMIT_FLEXIBILITY_EXERCISE_ANSWERS_FAILED);

export const FETCH_FLEXIBILITY_EXERCISE_QUESTIONS_SUCCEEDED =
    'FETCH_FLEXIBILITY_EXERCISE_QUESTIONS_SUCCEEDED';
export type FetchFlexibilityExerciseQuestionsSuccessAction = Action<
    typeof FETCH_FLEXIBILITY_EXERCISE_QUESTIONS_SUCCEEDED
>;
export const fetchFlexibilityExerciseQuestionsSuccess = creator<
    FetchFlexibilityExerciseQuestionsSuccessAction
>(FETCH_FLEXIBILITY_EXERCISE_QUESTIONS_SUCCEEDED);

export const FETCH_FLEXIBILITY_EXERCISE_QUESTIONS_FAILED =
    'FETCH_FLEXIBILITY_EXERCISE_QUESTIONS_FAILED';
export type FetchFlexibilityExerciseQuestionsFailAction = Action<
    typeof FETCH_FLEXIBILITY_EXERCISE_QUESTIONS_FAILED
>;
export const fetchFlexibilityExerciseQuestionsFail = creator<
    FetchFlexibilityExerciseQuestionsFailAction
>(FETCH_FLEXIBILITY_EXERCISE_QUESTIONS_FAILED);

export const FETCH_FLEXIBILITY_EXERCISE_ANSWERS_SUCCEEDED =
    'FETCH_FLEXIBILITY_EXERCISE_ANSWERS_SUCCEEDED';
export type FetchFlexibilityExerciseAnswersSuccessAction = Action<
    typeof FETCH_FLEXIBILITY_EXERCISE_ANSWERS_SUCCEEDED,
    SelectedAnswer[]
>;
export const fetchFlexibilityExerciseAnswersSuccess = creator<
    FetchFlexibilityExerciseAnswersSuccessAction
>(FETCH_FLEXIBILITY_EXERCISE_ANSWERS_SUCCEEDED);

export const FETCH_FLEXIBILITY_EXERCISE_ANSWERS_FAILED =
    'FETCH_FLEXIBILITY_EXERCISE_ANSWERS_FAILED';
export type FetchFlexibilityExerciseAnswersFailAction = Action<
    typeof FETCH_FLEXIBILITY_EXERCISE_ANSWERS_FAILED
>;
export const fetchFlexibilityExerciseAnswersFail = creator<
    FetchFlexibilityExerciseAnswersFailAction
>(FETCH_FLEXIBILITY_EXERCISE_ANSWERS_FAILED);

export const CHANGE_FLEXIBILITY_PRACTICE_ANSWER = 'CHANGE_FLEXIBILITY_PRACTICE_ANSWER';
export type ChangeFlexibilityPracticeAnswerAction = Action<
    typeof CHANGE_FLEXIBILITY_PRACTICE_ANSWER,
    ChangeFlexibilityPracticeAnswerArguments
>;
export const changeFlexibilityPracticeAnswer = creator<ChangeFlexibilityPracticeAnswerAction>(
    CHANGE_FLEXIBILITY_PRACTICE_ANSWER,
);

export const SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_REQUESTED =
    'SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_REQUESTED';
export type SubmitFlexibilityPracticeAnswerRequestAction = Action<
    typeof SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_REQUESTED,
    ContentAnswer
>;
export const submitFlexibilityPracticeAnswer = creator<
    SubmitFlexibilityPracticeAnswerRequestAction
>(SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_REQUESTED);

export const SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_SUCCEEDED =
    'SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_SUCCEEDED';
export type SubmitFlexibilityPracticeAnswerSuccessAction = Action<
    typeof SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_SUCCEEDED
>;
export const submitFlexibilityPracticeAnswerSuccess = creator<
    SubmitFlexibilityPracticeAnswerSuccessAction
>(SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_SUCCEEDED);

export const SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_FAILED =
    'SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_FAILED';
export type SubmitFlexibilityPracticeAnswerFailAction = Action<
    typeof SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_FAILED
>;
export const submitFlexibilityPracticeAnswerFail = creator<
    SubmitFlexibilityPracticeAnswerFailAction
>(SUBMIT_FLEXIBILITY_PRACTICE_ANSWER_FAILED);

export const FETCH_FLEXIBILITY_PRACTICE_QUESTION_SUCCEEDED =
    'FETCH_FLEXIBILITY_PRACTICE_QUESTION_SUCCEEDED';
export type FetchFlexibilityPracticeQuestionSuccessAction = Action<
    typeof FETCH_FLEXIBILITY_PRACTICE_QUESTION_SUCCEEDED
>;
export const fetchFlexibilityPracticeQuestionSuccess = creator<
    FetchFlexibilityPracticeQuestionSuccessAction
>(FETCH_FLEXIBILITY_PRACTICE_QUESTION_SUCCEEDED);

export const FETCH_FLEXIBILITY_PRACTICE_QUESTION_FAILED =
    'FETCH_FLEXIBILITY_PRACTICE_QUESTION_FAILED';
export type FetchFlexibilityPracticeQuestionFailAction = Action<
    typeof FETCH_FLEXIBILITY_PRACTICE_QUESTION_FAILED
>;
export const fetchFlexibilityPracticeQuestionFail = creator<
    FetchFlexibilityPracticeQuestionFailAction
>(FETCH_FLEXIBILITY_PRACTICE_QUESTION_FAILED);

export const FETCH_FLEXIBILITY_PRACTICE_ANSWER_SUCCEEDED =
    'FETCH_FLEXIBILITY_PRACTICE_ANSWER_SUCCEEDED';
export type FetchFlexibilityPracticeAnswerSuccessAction = Action<
    typeof FETCH_FLEXIBILITY_PRACTICE_ANSWER_SUCCEEDED
>;
export const fetchFlexibilityPracticeAnswerSuccess = creator<
    FetchFlexibilityPracticeAnswerSuccessAction
>(FETCH_FLEXIBILITY_PRACTICE_ANSWER_SUCCEEDED);

export const FETCH_FLEXIBILITY_PRACTICE_ANSWER_FAILED = 'FETCH_FLEXIBILITY_PRACTICE_ANSWER_FAILED';
export type FetchFlexibilityPracticeAnswerFailAction = Action<
    typeof FETCH_FLEXIBILITY_PRACTICE_ANSWER_FAILED
>;
export const fetchFlexibilityPracticeAnswerFail = creator<FetchFlexibilityPracticeAnswerFailAction>(
    FETCH_FLEXIBILITY_PRACTICE_ANSWER_FAILED,
);

export const CHANGE_FLEXIBILITY_PLAN_FIELD = 'CHANGE_FLEXIBILITY_PLAN_FIELD';
export type ChangeFlexibilityPlanFieldAction = Action<
    typeof CHANGE_FLEXIBILITY_PLAN_FIELD,
    ChangeFlexibilityExerciseFieldActionArguments
>;
export const changeFlexibilityPlanField = creator<ChangeFlexibilityPlanFieldAction>(
    CHANGE_FLEXIBILITY_PLAN_FIELD,
);

export const CHANGE_FLEXIBILITY_PLAN_INPUT = 'CHANGE_FLEXIBILITY_PLAN_INPUT';
export type ChangeFlexibilityPlanInputAction = Action<
    typeof CHANGE_FLEXIBILITY_PLAN_INPUT,
    ChangeFlexibilityPlanInputArguments
>;
export const changeFlexibilityPlanInput = creator<ChangeFlexibilityPlanInputAction>(
    CHANGE_FLEXIBILITY_PLAN_INPUT,
);

export const SUBMIT_FLEXIBILITY_PLAN_DATA_REQUESTED = 'SUBMIT_FLEXIBILITY_PLAN_DATA_REQUESTED';
export type SubmitFlexibilityPlanDataRequestAction = Action<
    typeof SUBMIT_FLEXIBILITY_PLAN_DATA_REQUESTED,
    SelectedAnswer[]
>;
export const submitFlexibilityPlanData = creator<SubmitFlexibilityPlanDataRequestAction>(
    SUBMIT_FLEXIBILITY_PLAN_DATA_REQUESTED,
);

export const SUBMIT_FLEXIBILITY_PLAN_DATA_SUCCEEDED = 'SUBMIT_FLEXIBILITY_PLAN_DATA_SUCCEEDED';
export type SubmitFlexibilityPlanDataSuccessAction = Action<
    typeof SUBMIT_FLEXIBILITY_PLAN_DATA_SUCCEEDED
>;
export const submitFlexibilityPlanDataSuccess = creator<SubmitFlexibilityPlanDataSuccessAction>(
    SUBMIT_FLEXIBILITY_PLAN_DATA_SUCCEEDED,
);

export const SUBMIT_FLEXIBILITY_PLAN_DATA_FAILED = 'SUBMIT_FLEXIBILITY_PLAN_DATA_FAILED';
export type SubmitFlexibilityPlanDataFailAction = Action<
    typeof SUBMIT_FLEXIBILITY_PLAN_DATA_FAILED
>;
export const submitFlexibilityPlanDataFail = creator<SubmitFlexibilityPlanDataFailAction>(
    SUBMIT_FLEXIBILITY_PLAN_DATA_FAILED,
);

export const FETCH_FLEXIBILITY_PLAN_DATA_SUCCEEDED = 'FETCH_FLEXIBILITY_PLAN_DATA_SUCCEEDED';
export type FetchFlexibilityPlanDataSuccessAction = Action<
    typeof FETCH_FLEXIBILITY_PLAN_DATA_SUCCEEDED
>;
export const fetchFlexibilityPlanDataSuccess = creator<FetchFlexibilityPlanDataSuccessAction>(
    FETCH_FLEXIBILITY_PLAN_DATA_SUCCEEDED,
);

export const FETCH_FLEXIBILITY_PLAN_DATA_FAILED = 'FETCH_FLEXIBILITY_PLAN_DATA_FAILED';
export type FetchFlexibilityPlanDataFailAction = Action<typeof FETCH_FLEXIBILITY_PLAN_DATA_FAILED>;
export const fetchFlexibilityPlanDataFail = creator<FetchFlexibilityPlanDataFailAction>(
    FETCH_FLEXIBILITY_PLAN_DATA_FAILED,
);

export const FETCH_FLEXIBILITY_PLAN_ANSWERS_SUCCEEDED = 'FETCH_FLEXIBILITY_PLAN_ANSWERS_SUCCEEDED';
export type FetchFlexibilityPlanAnswersSuccessAction = Action<
    typeof FETCH_FLEXIBILITY_PLAN_ANSWERS_SUCCEEDED,
    SelectedAnswer[]
>;
export const fetchFlexibilityPlanAnswersSuccess = creator<FetchFlexibilityPlanAnswersSuccessAction>(
    FETCH_FLEXIBILITY_PLAN_ANSWERS_SUCCEEDED,
);

export const FETCH_FLEXIBILITY_PLAN_ANSWERS_FAILED = 'FETCH_FLEXIBILITY_PLAN_ANSWERS_FAILED';
export type FetchFlexibilityPlanAnswersFailAction = Action<
    typeof FETCH_FLEXIBILITY_PLAN_ANSWERS_FAILED
>;
export const fetchFlexibilityPlanAnswersFail = creator<FetchFlexibilityPlanAnswersFailAction>(
    FETCH_FLEXIBILITY_PLAN_ANSWERS_FAILED,
);

export const CHANGE_ACCOMPLISHED_ACTIVITY_FIELD = 'CHANGE_ACCOMPLISHED_ACTIVITY_FIELD';
export type ChangeAccomplishedActivityFieldAction = Action<
    typeof CHANGE_ACCOMPLISHED_ACTIVITY_FIELD,
    ChangeAccomplishedActivityFieldActionArguments
>;
export const changeAccomplishedActivityStatus = creator<ChangeAccomplishedActivityFieldAction>(
    CHANGE_ACCOMPLISHED_ACTIVITY_FIELD,
);

export const CHANGE_ACCOMPLISHED_ACTIVITY_FEELING = 'CHANGE_ACCOMPLISHED_ACTIVITY_FEELING';
export type ChangeAccomplishedActivityFeelingAction = Action<
    typeof CHANGE_ACCOMPLISHED_ACTIVITY_FEELING,
    ChangeAccomplishedActivityFeelingActionArguments
>;
export const changeAccomplishedActivityFeeling = creator<ChangeAccomplishedActivityFeelingAction>(
    CHANGE_ACCOMPLISHED_ACTIVITY_FEELING,
);

export const FETCH_FLEXIBILITY_HOMEWORK_DATA_REQUESTED =
    'FETCH_FLEXIBILITY_HOMEWORK_DATA_REQUESTED';
export type FetchFlexibilityHomeworkDataRequestAction = Action<
    typeof FETCH_FLEXIBILITY_HOMEWORK_DATA_REQUESTED
>;
export const fetchFlexibilityHomeworkDataRequest = creator<
    FetchFlexibilityHomeworkDataRequestAction
>(FETCH_FLEXIBILITY_HOMEWORK_DATA_REQUESTED);

export const FETCH_FLEXIBILITY_HOMEWORK_DATA_SUCCEEDED =
    'FETCH_FLEXIBILITY_HOMEWORK_DATA_SUCCEEDED';
export type FetchFlexibilityHomeworkDataSuccessAction = Action<
    typeof FETCH_FLEXIBILITY_HOMEWORK_DATA_SUCCEEDED
>;
export const fetchFlexibilityHomeworkDataSuccess = creator<
    FetchFlexibilityHomeworkDataSuccessAction
>(FETCH_FLEXIBILITY_HOMEWORK_DATA_SUCCEEDED);

export const FETCH_FLEXIBILITY_HOMEWORK_DATA_FAILED = 'FETCH_FLEXIBILITY_HOMEWORK_DATA_FAILED';
export type FetchFlexibilityHomeworkDataFailAction = Action<
    typeof FETCH_FLEXIBILITY_HOMEWORK_DATA_FAILED
>;
export const fetchFlexibilityHomeworkDataFail = creator<FetchFlexibilityHomeworkDataFailAction>(
    FETCH_FLEXIBILITY_HOMEWORK_DATA_FAILED,
);

export const SUBMIT_FLEXIBILITY_HOMEWORK_DATA_REQUESTED =
    'SUBMIT_FLEXIBILITY_HOMEWORK_DATA_REQUESTED';
export type SubmitFlexibilityHomeworkDataRequestAction = Action<
    typeof SUBMIT_FLEXIBILITY_HOMEWORK_DATA_REQUESTED,
    PlannedActivity[]
>;
export const submitFlexibilityHomeworkData = creator<SubmitFlexibilityHomeworkDataRequestAction>(
    SUBMIT_FLEXIBILITY_HOMEWORK_DATA_REQUESTED,
);

export const SUBMIT_FLEXIBILITY_HOMEWORK_DATA_SUCCEEDED =
    'SUBMIT_FLEXIBILITY_HOMEWORK_DATA_SUCCEEDED';
export type SubmitFlexibilityHomeworkDataSuccessAction = Action<
    typeof SUBMIT_FLEXIBILITY_HOMEWORK_DATA_SUCCEEDED
>;
export const submitFlexibilityHomeworkDataSuccess = creator<
    SubmitFlexibilityHomeworkDataSuccessAction
>(SUBMIT_FLEXIBILITY_HOMEWORK_DATA_SUCCEEDED);

export const SUBMIT_FLEXIBILITY_HOMEWORK_DATA_FAILED = 'SUBMIT_FLEXIBILITY_HOMEWORK_DATA_FAILED';
export type SubmitFlexibilityHomeworkDataFailAction = Action<
    typeof SUBMIT_FLEXIBILITY_HOMEWORK_DATA_FAILED
>;
export const submitFlexibilityHomeworkDataFail = creator<SubmitFlexibilityHomeworkDataFailAction>(
    SUBMIT_FLEXIBILITY_HOMEWORK_DATA_FAILED,
);

export type WeekFourAction =
    | ChangeFlexibilityExerciseAnswerAction
    | SubmitFlexibilityExerciseAnswersRequestAction
    | SubmitFlexibilityExerciseAnswersSuccessAction
    | SubmitFlexibilityExerciseAnswersFailAction
    | FetchFlexibilityExerciseQuestionsSuccessAction
    | FetchFlexibilityExerciseQuestionsFailAction
    | ChangeFlexibilityPracticeAnswerAction
    | SubmitFlexibilityPracticeAnswerRequestAction
    | SubmitFlexibilityPracticeAnswerSuccessAction
    | SubmitFlexibilityPracticeAnswerFailAction
    | FetchFlexibilityPracticeQuestionSuccessAction
    | FetchFlexibilityPracticeQuestionFailAction
    | ChangeFlexibilityPlanFieldAction
    | SubmitFlexibilityPlanDataRequestAction
    | SubmitFlexibilityPlanDataSuccessAction
    | SubmitFlexibilityPlanDataFailAction
    | FetchFlexibilityPlanDataSuccessAction
    | FetchFlexibilityPlanDataFailAction
    | FetchFlexibilityPlanAnswersSuccessAction
    | FetchFlexibilityPlanAnswersFailAction
    | ChangeAccomplishedActivityFieldAction
    | ChangeAccomplishedActivityFeelingAction
    | FetchFlexibilityHomeworkDataRequestAction
    | FetchFlexibilityHomeworkDataSuccessAction
    | FetchFlexibilityHomeworkDataFailAction
    | SubmitFlexibilityHomeworkDataRequestAction
    | SubmitFlexibilityHomeworkDataSuccessAction
    | SubmitFlexibilityHomeworkDataFailAction
    | SubmitFlexibilityHomeworkDataFailAction
    | FetchFlexibilityPracticeAnswerFailAction
    | FetchFlexibilityPracticeAnswerSuccessAction
    | FetchFlexibilityExerciseAnswersSuccessAction
    | FetchFlexibilityExerciseAnswersFailAction
    | ChangeFlexibilityPlanInputAction;
